import BaseController from '../base_controller'

export default class extends BaseController {

  static targets = [
    ...super.targets,
    'acuteMedicationNoneInverse',
    'ampathItemsNoneOfTheAbove',
    'chronicMedicationNoneInverse',
    'fastingInformation',
    'mnemonic',
    'otherAcuteMedicationDetailsInput',
    'otherAcuteMedicationDetailsTemplate',
    'otherAcuteMedicationDetailsWrapper',
    'otherChronicMedicationDetailsInput',
    'otherChronicMedicationDetailsTemplate',
    'otherChronicMedicationDetailsWrapper',
    'sendAmpathRequisition',
    'sendOtherRequisition',
    'requiredTestInformation'
  ]

  static outlets = ['consultation-note']

  toggleSendAmpathRequisition({ currentTarget }) {
    this.toggleTarget(this.sendAmpathRequisitionTarget, currentTarget.value === 'ampath')
  }

  toggleSendOtherRequisition({ currentTarget }) {
    this.toggleTarget(this.sendOtherRequisitionTarget, currentTarget.value === '000000')
  }

  toggleRequiredTestInformation() {
    this.toggleFastingInformation()
    this.toggleTargets(this.requiredTestInformationTargets, this.showRequiredTestInformation())
  }

  toggleFastingInformation() {
    this.toggleTarget(this.fastingInformationTarget, this.showFastingInformation())
  }

  toggleChronicMedicationNoneInverse({ currentTarget }) {
    this.toggleTarget(this.chronicMedicationNoneInverseTarget, !currentTarget.checked)
  }

  toggleAmpathItemsNoneOfTheAbove() {
    this.toggleTarget(this.ampathItemsNoneOfTheAboveTarget, this.showAmpathItemsNoneOfTheAbove())
  }

  addOtherChronicMedicationDetailsItem() {
    this.addNestedForm({
      list:     this.otherChronicMedicationDetailsInputTargets,
      template: this.otherChronicMedicationDetailsTemplateTarget,
      wrapper:  this.otherChronicMedicationDetailsWrapperTarget
    })
  }

  removeOtherChronicMedicationDetailsItem(event) {
    this.removeNestedForm({
      button:    event.currentTarget,
      wrapper:   this.otherChronicMedicationDetailsWrapperTarget,
      list:      this.otherChronicMedicationDetailsInputTargets
    })

    if (this.hasConsultationNoteOutlet) {
      this.consultationNoteOutlet.autoSave(event)
    }
  }

  toggleAcuteMedicationNoneInverse({ currentTarget }) {
    this.toggleTarget(this.acuteMedicationNoneInverseTarget, !currentTarget.checked)
  }

  addOtherAcuteMedicationDetailsItem() {
    this.addNestedForm({
      list:      this.otherAcuteMedicationDetailsInputTargets,
      template:  this.otherAcuteMedicationDetailsTemplateTarget,
      wrapper:   this.otherAcuteMedicationDetailsWrapperTarget
    })
  }

  removeOtherAcuteMedicationDetailsItem(event) {
    this.removeNestedForm({
      button:  event.currentTarget,
      wrapper: this.otherAcuteMedicationDetailsWrapperTarget,
      list:    this.otherAcuteMedicationDetailsInputTargets
    })

    if (this.hasConsultationNoteOutlet) {
      this.consultationNoteOutlet.autoSave(event)
    }
  }

  showAmpathItemsNoneOfTheAbove() {
    return this.mnemonicTargets.some((mnemonic) => mnemonic.value === this.conditionNoneValue && mnemonic.checked)
  }

  showRequiredTestInformation() {
    return this.mnemonicTargets.some((mnemonic) => mnemonic.checked && mnemonic.value !== this.conditionNoneValue)
  }

  showFastingInformation() {
    return this.mnemonicTargets.some((mnemonic) => ['CH', 'LIPO', 'LDL'].includes(mnemonic.value) && mnemonic.checked)
  }

}
